module.exports = "https://cdn.realtymogul.com/static/media/MRII.5c163f5e.jpg";